import { FC } from "react";
import ThankYouScreenWrapper, { ThankYouScreenProps } from "./ThankYouScreenWrapper.tsx";

const ThankYouScreenMetaTrader: FC<ThankYouScreenProps> = (props) => {
  const isLive = props.context !== "Demo";
  const title = isLive ? "Application received" : "Your demo account is ready.";

  return (
    <ThankYouScreenWrapper {...props} title={title} disableOnMobile>
      <div>
        {isLive && (
          <div className="w-full mb-6">
            <p className="text-base leading-6 text-content-secondary">
              We're reviewing your application. You'll receive an email shortly with the next steps.
            </p>
          </div>
        )}

        {isLive && (
          <div className="w-full mb-6">
            <p className="text-base leading-6 text-content-secondary">
              <span className="font-bold">Your demo account is ready</span>
              <br />
              To log in, visit www.cmcmarkets.com
            </p>
          </div>
        )}

        {!isLive && (
          <div className="w-full mb-6">
            <p className="text-base leading-6 text-content-secondary">
              To log in, visit www.cmcmarkets.com
            </p>
          </div>
        )}
      </div>
    </ThankYouScreenWrapper>
  );
};

export default ThankYouScreenMetaTrader;
